import React,{ useState, useEffect, useContext } from 'react';
import MaterialTable from 'material-table';
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import { api } from 'common';
import { useTranslation } from "react-i18next";
import moment from 'moment/min/moment-with-locales';
import { buildCsvExport } from '../common/sharedFunctions';
const Withdraws = () => {
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector(state => state.settingsdata.settings);
  const {
    completeWithdraw
  } = api;
  const dispatch = useDispatch();
  const columns =  [
      { title: 'ID', field: 'id',editable: 'never',headerStyle:{textAlign:'center'},cellStyle:{textAlign:'center'}},
      { title: t('requestDate'), field: 'date', editable: 'never', defaultSort: 'desc', render: rowData => rowData.date? moment(rowData.date).format('lll') : null, exportTransformer: rowData => new Date(rowData.date).toLocaleDateString() + " " + new Date(rowData.date).toLocaleTimeString()},
      { title: t('driver_name'),field: 'name',editable: 'never', cellStyle:{textAlign:'center'},headerStyle:{textAlign:'center'}},
      { title: t('user_type'), field: 'usertype', editable: 'never', render: rowData => {
          const usertype = rowData.usertype || 'customer';
          const label = usertype.charAt(0).toUpperCase() + usertype.slice(1);
          return rowData.isAgent ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ backgroundColor: '#007bff', color: 'white', padding: '2px 8px', borderRadius: '12px', fontSize: '0.8em', marginRight: '5px' }}>AGENT</span>
              <span style={{ color: '#28a745', fontSize: '0.8em' }}>No Fee</span>
            </div>
          ) : label;
        }},
      { title: t('amount'), field: 'amount',editable: 'never',cellStyle:{textAlign:'center'},headerStyle:{textAlign:'center'}, render: rowData => rowData.amount? (settings.swipe_symbol? rowData.amount + " " + settings.symbol : settings.symbol + " " + rowData.amount) : (settings.swipe_symbol? "0 " + settings.symbol : settings.symbol + " 0")},
      { title: t('processed'), field: 'processed', type: 'boolean',editable: 'never', cellStyle:{paddingLeft:isRTL=== 'rtl'?40:null}},  
      { title: t('processDate'), field: 'processDate', editable: 'never', render: rowData => rowData.processDate? moment(rowData.processDate).format('lll') : null}, 
      { title: t('bankName'), field: 'bankName', hidden: settings.bank_fields===false? true: false,editable: 'never'},
      { title: t('bankCode'), field: 'bankCode' , hidden: settings.bank_fields===false? true: false,editable: 'never'},
      { title: t('bankAccount'), field: 'bankAccount', hidden: settings.bank_fields===false? true: false,editable: 'never'}
  ];
  const [data, setData] = useState([]);
  const withdrawdata = useSelector(state => state.withdrawdata);

  useEffect(()=>{
        if(withdrawdata.withdraws){
            setData(withdrawdata.withdraws);
        }else{
          setData([]);
        }
  },[withdrawdata.withdraws]);
  
  return (
    withdrawdata.loading? <CircularLoading/>:
    <MaterialTable
      title={t('Withdraw_title')}
      style={{direction:isRTL ==='rtl'?'rtl':'ltr', padding: 10}}
      columns={columns}
      data={data}
      options={{
        exportCsv: (columns, data) => buildCsvExport(columns, data, ['date', 'processDate']),
        exportButton: { csv: true, pdf: false }
      }}
      localization={{
        toolbar: {
          searchPlaceholder: (t('search')),
          exportTitle: (t('export')),
        },
        header: {
          actions: (t('actions')) 
      },
      pagination: {
        labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
        labelRowsSelect: (t('rows')),
        firstTooltip: (t('first_page_tooltip')),
        previousTooltip: (t('previous_page_tooltip')),
        nextTooltip: (t('next_page_tooltip')),
        lastTooltip: (t('last_page_tooltip'))
      },
      }}
      actions={[
        rowData => ({
          icon: 'check',
          tooltip: t('process_withdraw'),
          disabled: rowData.processed,
          onClick: (event, rowData) => {
            dispatch(completeWithdraw(rowData));
          }         
        }),
      ]}
    />
  );
}

export default Withdraws;
